import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noPriority: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noPriority: {
		id: 'issue-table-grouping.group-row.group-header.priority-group-header.no-priority',
		defaultMessage: 'No priority',
		description: 'Label for grouped items without priority',
	},
});
export default messages;
